export const navLinksData = [
  {
    _id: 1,
    title: "Home",
    link: "home",
  },
  {
    _id: 2,
    title: "About",
    link: "about",
  },
  {
    _id: 3,
    title: "Projects",
    link: "projects",
  },
  {
    _id: 5,
    title: "Architecture",
    link: "architecture",
  },
  {
    _id: 7,
    title: "Operations",
    link: "operations",
  },
  {
    _id: 6,
    title: "Experience",
    link: "resume",
  },
];
